exports.IDS = {
  // IMG_URL: "http://127.0.0.1:4242",
  // IMG_URL: "http://192.168.16.23:7778",
  // IMG_URL: "https://jeeto777node.profcymadev.com:7778",
  IMG_URL: "https://node.jeeto777.com",


  PAGE: 1,
  PERPAGE: 10,
  TOTALPAGES: 1,
  TOTAL: 1,
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  BLOCK: "BLOCKED",
  UNBLOCK: "UNBLOCKED",
  SLICESTATUS: {
    Idle: "idle",
    Loading: "loading",
    Succeeded: "succeeded",
    Failed: "failed",
  },
};
